module.exports = __webpack_public_path__ + "static/media/icon-park-solid_right-c.bb47f191.svg";